// plugins/localStoragePlugin.js
import store from "~/store";

export default defineNuxtPlugin((nuxtApp) => {
  store.subscribe((mutation, state) => {
    if (process.client) {
      localStorage.setItem(
        "persistedState",
        JSON.stringify(state.persistedState)
      );
    }
  });
});
